import React, { useEffect, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown, faChevronUp, faSortUp, faSortDown, faX, faPaperclip, faPlus, faPen, 
  faMobileAndroidAlt, faSave, faTimes, faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import '../Css/Tooltip.css';
import { Loader, Spinner } from '../Loader/Loader';
import { decryptData } from '../../utils/storageCrypto';

const HubDetails = () => {
  const navigate = useNavigate();
  const [hubs, setHubs] = useState([]);
  const location = useLocation();
  const { hubData } = location.state;
  console.log(hubData);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [showAddress, setShowAddress] = useState(false);
  const [selectedHub, setSelectedHub] = useState(null);
  const [hubId, setHubId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  console.log(backendApiUrl);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hubStatus, setHubStatus] = useState('Deactivate');
  const RETRY_LIMIT = 3;
  const [retryCount, setRetryCount] = useState(0);
  const [isAddressEditing, setIsAddressEditing] = useState(false);
  const [address1, setAddress] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [pincode, setPincode] = useState();
  const [isGSTEditing, setIsGSTEditing] = useState(false);
const [GSTValue, setGSTValue] = useState();
const [isPanEditing, setIsPanEditing] = useState(false);
const [panValue, setPanValue] = useState();
const [mappedHubs, setMappedHubs] = useState([]);
const [showLocation, setShowLocation] = useState(false);

useEffect(() => {
  console.log('hubData in useEffect:', hubData);
  if (hubData) {
    fetchHubs(hubData);
  }
}, [hubData]);

const fetchHubs = async (Hub, attempt = 0) => {
  console.log('Fetching hubs...', Hub);
  try {
    const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

    console.log('Token:', token);
    const url = `${process.env.REACT_APP_FORE_BRICKBUCKET}hub/get-all-hubs`;
    console.log('Fetch URL:', url);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
    });

    console.log('Response status:', response.status);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Fetched data:', data);

    if (data.status === 200 || data.status === 201 || data.status === 204) {
      //const hubsData = data.data;
      setHubs(data.data);  
      console.log('Set hubs:', data.data);

      const mappedData = data.data.map((hub) => ({
        _id: hub._id,
        hub_name: hub.hub_name,
        company_name: hub.company_name,
        mobile_number: hub.mobile_number,
        email: hub.email,
        gst: hub.gst,
        pan: hub.pan,
        address1: hub.address1,
        city: hub.city,
        state: hub.state,
        pincode: hub.pincode,
        hub_number: hub.hub_number,
        website_url: hub.website_url,
        logo: hub.logo,
        

        
      }));
  
      setMappedHubs(mappedData);
  

      const FindHub = data.data.find((p) => p._id === Hub._id);
      
        handleHubClick(FindHub);
      
      setIsLoading(false);
    } else {
      throw new Error(data.message || 'Unknown error occurred');
    }
   } catch (error) {
      console.error('Failed to fetch:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchHubs(Hub, attempt + 1), 1000);
      } else {
        setIsLoading(false);
        setPopupMessage(error.message || 'Failed to fetch hubs. Please try again.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchHubs(Hub, 0));
      }
    }
  };
  
  const fetchHubsByHubId = async (hubId, attempt = 1) => {
    console.log(hubId);
    try {
      const encryptedToken = sessionStorage.getItem('token');
                const token = decryptData(encryptedToken);

      console.log(token);
      const getHubs = `${backendApiUrl}hub/get-hub-by-id?hubId=${hubId}`;
      console.log(getHubs);
      const response = await fetch(getHubs, {
    
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'x-token': token
        },
      });
      const data = await response.json();
      console.log(data);
      if (data.status === 200 || data.status === 201 || data.status === 204) {
        setHubs(data.data)
         
      } else if (data.status === 404) {
        setHubs([]);
        setPopupMessage(data.message);
        setPopupType('404');
        setShowPopup(true);
      } else if (data.status === 500) {
        setPopupMessage(data.message);
        setPopupType('500');
        setRetryFunction(() => fetchHubsByHubId);
        setShowPopup(true);
      } else {
        setPopupMessage(data.message);
        setPopupType(`${data.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => fetchHubsByHubId(hubId, attempt + 1), 1000);
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchHubsByHubId(hubId, attempt));
      }
    }
  };
  
  useEffect(() => {
    if (hubId) {
      fetchHubsByHubId(hubId);
    }
  }, [hubId]);
  console.log(hubId);
  
    const openGoogleMaps = useCallback(() => {
    const { latitude, longitude } = selectedHub;
    const url = `https://www.google.com/maps?q=${latitude},${longitude}&z=15`;
    window.open(url, '_blank');
  }, [selectedHub]);


  const handleHubClick = (hub) => {
    setHubId(hub._id);
    setSelectedHub(hub);
  };
    
  const handleToggleAddress = () => {
    setShowAddress(!showAddress);
    setShowOtherDetails(false);
  };

  const handleEditAddress = () => {
    setIsAddressEditing(true);
  };

  const handleCancelClick = () => {
    setIsAddressEditing(false);
    setAddress(selectedHub?.address || '');
    setCity(selectedHub?.city || '');
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };
  
  

  const handleToggleOtherDetails = () => {
    setShowOtherDetails(!showOtherDetails);
    setShowAddress(false);
  };

  const handleToggleLocation = () => {
  setShowLocation(!showLocation);
  setShowAddress(false);
};

  const handleHubInputfieldChange = (e) => {
    const { id, value } = e.target;
    setSelectedHub((prevSelectedHub) => ({
       ...prevSelectedHub,
       [id]: value
    }));
  };

  const handleUpdateHub = async (attempt = 1) => {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);

    const url = `${backendApiUrl}hub/update-hub`;

    const errorMessages = [];
    if (!selectedHub.name) {
      errorMessages.push('Name is required.');
    }
    if (!selectedHub.mobile_number) {
      errorMessages.push('Mobile number is required.');
    } else if (selectedHub.mobile_number.length !== 10) {
      errorMessages.push('Mobile number must be exactly 10 digits.');
    }
    if (selectedHub.email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(selectedHub.email)) {
        errorMessages.push('Invalid email address.');
      }
    }

    if (errorMessages.length > 0) {
      setErrorMessages(errorMessages);
      setIsSaving(false);
      return;
    }

    setIsSaving(true);
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(selectedHub)
      });
      const responseData = await response.json();
      if (responseData.status === 200 || responseData.status === 201 || responseData.status === 204) {
        handleSetUpdatingHubsData(selectedHub);
        setIsLoading(false);
        setIsSaving(false);
        setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage(responseData.message);
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      } else if (responseData.status === 500) {
        setIsLoading(false);
        setIsSaving(false);
        setShowPopup(true);
        setPopupType('500');
        setRetryFunction(() => handleUpdateHub);
        setPopupMessage(responseData.message);
      } else {
        setIsSaving(false);
        setIsLoading(false);
        setPopupMessage(responseData.message);
        setPopupType(`${responseData.status}`);
        setShowPopup(true);
      }
    } catch (error) {
      console.error('Failed to fetch:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1);
        setTimeout(() => handleUpdateHub(attempt + 1), 1000);
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleUpdateHub(attempt));
      }
    } finally {
      setErrorMessages([]);
    }
  };

  const handleSetUpdatingHubsData = async (selectedHub) => {
    const FindingHubIndex = hubs.findIndex(p => p._id === selectedHub._id);
    if (FindingHubIndex !== -1) {
      const updatedHubs = hubs.map((hub, index) =>
        index === FindingHubIndex
          ? { ...hub, ...selectedHub }
          : hub
      );
      setHubs(updatedHubs);
    }
  };

  const sortArray = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });

    const sortedArray = [...hubs].sort((a, b) => {
      if (a[key] < b[key]) {
       return direction === 'ascending' ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
    setHubs(sortedArray);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
    }
    return null;
  };

  

  const handleCreateHub = () => {
    navigate('/bb/app/settings/newhub');
  };

  const HandleClose = () => {
    navigate('/bb/app/purchases/hubslist');
  };

  const handleCloseError = () => {
    setErrorMessages([]);
  };

  const handleEdit = () => {
    navigate('/bb/app/settings/EditHub', { state: { HubData: selectedHub } });
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  if (isLoading) {
    return <Loader />;
  }

  const Retry = async () => {
    setIsLoading(true);
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction();
      }
      setIsLoading(false);
    }, 5000);
    setShowPopup(false);
  };

  const BackToLoginPage = () => {
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
    navigate('/bb');
  };

  return (
    <div className="bg-white flex flex-row w-full justify-center overflow-y-hidden">
      {/* List of Hubs Div start */}
      <div className="flex flex-col w-[32%]">
        <div className="p-4 border-b flex flex-row justify-between">
          <div>
            <h5 className="text-md font-semibold cursor-pointer">
              All Hubs
              <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer" />
            </h5>
          </div>
          <div>
            <button
              className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md"
              data-tooltip="Create Hub"
              title=""
              style={{ '--tooltip-bg': 'black' }}
              onClick={handleCreateHub}
            >
              <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />
            </button>
          </div>
        </div>
        <div className=" flex justify-center  overflow-y-hidden  flex-col ">
  <div className='flex  flex-col h-[80vh]  overflow-y-auto '>
    {mappedHubs.map((hub) => (
      <div key={hub._id} onClick={() => handleHubClick(hub)} className={`border-b text-sm flex items-center px-4 py-2 ${hubId === hub._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}>
        <div className='flex flex-row'>
          <div>
         <input
         type="checkbox"
               className="mr-2 w-3 h-3 accent-blue-600 cursor-pointer"
                />     
               </div>
          <div className='flex flex-col'>
            <p className='text-md font-semibold'>{hub.hub_name}</p>
            <p className="text-gray-600 text-sm">{hub.company_name}</p>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>

</div>


      {/* List of Hubs Div end */}
  
      <div className="border-l w-full flex flex-col">
        {selectedHub ? (
          <>
            <div className="border-b h-24">
              <div className='p-4 flex justify-between items-center'>
                <span className="text-md font-semibold">{selectedHub.hub_name}</span>
                <div className="flex items-center px-2">
                <button className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md mr-2" onClick={handleEdit}>
                    Edit
                  </button>    
                    
                  
                     <button className="text-white px-1 py-1 rounded-md"
                    title="" data-tooltip="Close" style={{ '--tooltip-bg': 'black' }}>  
                    <FontAwesomeIcon icon={faX} onClick={HandleClose} className="text-md text-[#f7525a] mx-2 cursor-pointer" />
                  </button>
                </div>
              </div>
            </div>
            <div className="flex h-5/6 w-full overflow-y-auto flex-row">
              <div className="bg-[#fbfbfb] w-[32%] border-r p-4">
                <h2 className="text-sm pb-2 border-b">
                  {selectedHub.company_name}
                </h2>
                <div className='pt-4 pl-4 pr-4 flex flex-row'>
                  <div className='flex-shrink-0'>
                    <img className="rounded-md w-10 h-10 cursor-pointer" src={'/ProfileImageSvg.jpg'} alt="Brick Bucket Logo" />
                  </div>
                  <div className='text-sm ml-3 flex flex-col'>
                    <div className='font-semibold mb-0.5 break-words word-break'>{selectedHub.name}</div>
                    <div className='break-words word-break'>{selectedHub.email}</div>
                    <div className='break-words word-break'>
                      <FontAwesomeIcon icon={faMobileAndroidAlt} className='mr-1 text-xs'/>
                      {selectedHub.mobile_number}
                    </div>
                    <div className='text-xs flex flex-row'>
                      <button onClick={handleEdit} className='text-[#408dfb] hover:text-blue-600'>Edit</button>
                      {/* <p className='text-gray-300 ml-2 mr-2'>|</p> */}
                      <button
                        // onClick={selectedHub.is_active ? handleDeactivateClick : handleActivateClick}
                        className='text-[#408dfb] hover:text-blue-600'
                      >
                        {/* {selectedHub.is_active ? 'Deactivate' : 'Activate'} */}
                      </button>
                    </div>
                  </div>
                </div>
  
                <div onClick={handleToggleAddress} className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
                  <span className='text-sm cursor-pointer' onClick={handleToggleAddress}>ADDRESS</span>
                  <button className='text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleAddress}>
                    {showAddress ? <FontAwesomeIcon icon={faChevronUp} className='text-xs text-blue-800'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs text-blue-800'/>}
                  </button>
                </div>
  
                <div className={`${showAddress ? '' : 'hidden'}`}>
                  <div className='text-sm pt-2 pl-4 pr-4'>
                    <div className='flex justify-between'>
                      <h1> Address</h1>
                      {/* {!isAddressEditing &&
                        <FontAwesomeIcon icon={faPen} className='text-xs' onClick={handleEditAddress}/>
                      } */}
                    </div>
  
                    <div className='flex flex-col'>
                      <div className='flex flex-row hover:bg-[#d7d7ec] hover:rounded-md'>
                        <div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex justify-end'>
                          {isAddressEditing ? (
                            <div className='flex flex-col space-y-2'>
                              <input
                                type="text"
                                value={address1}
                                onChange={(e) => {setAddress(e.target.value); selectedHub.address1 = e.target.value}}
                                className="border border-gray-300 w-30 rounded px-2 py-1"
                              />
                              <input
                                type="text"
                                value={city}
                                onChange={(e) => {setCity(e.target.value); selectedHub.city = e.target.value}}
                                className="border border-gray-300 w-30 rounded px-2 py-1"
                              />
                                <input
                                type="text"
                                value={state}
                                onChange={(e) => {setState(e.target.value); selectedHub.state = e.target.value}}
                                className="border border-gray-300 w-30 rounded px-2 py-1"
                              />
                                <input
                                type="text"
                                value={pincode}
                                onChange={(e) => {setPincode(e.target.value); selectedHub.pincode = e.target.value}}
                                className="border border-gray-300 w-30 rounded px-2 py-1"
                              />
                            
                            
                            </div>
                          ) : (
                            <>
                              <div className='flex flex-col space-y-2'>
                                <p>{selectedHub.address1}</p>
                                <p>{selectedHub.city}</p>
                                <p>{selectedHub.state}</p>
                                <p>{selectedHub.pincode}</p>


                              </div>
                            </>
                          )}
                          <div className='flex items-center'>
                            {isSaving && (
                              <Spinner/>
                            )}
                            {isAddressEditing && (
                              <>
                                <FontAwesomeIcon
                                  icon={faSave}
                                  className='mr-2 text-xs ml-2 cursor-pointer'
                                  onClick={handleUpdateHub}
                                />
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className='mr-2 text-xs ml-2 cursor-pointer'
                                  onClick={handleCancelClick}
                                />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div onClick={handleToggleOtherDetails} className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
                  <span className='text-sm cursor-pointer' onClick={handleToggleOtherDetails}>TAX DETAILS</span>
                  <button className='text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleOtherDetails}>
                    {showOtherDetails ? <FontAwesomeIcon icon={faChevronUp} className='text-xs text-blue-800'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs text-blue-800'/>}
                  </button>
                </div>
  
                <div className={`${showOtherDetails ? '' : 'hidden'} mt-2 mb-2 flex flex-col`}>
                  <div className='flex flex-row pb-2'>
                    <div className='text-[#212529] text-xs pt-2 pl-2 pr-2 w-32'>
                      <h1>GST</h1>
                    </div>
                    <div className='flex flex-row hover:bg-[#d7d7ec] hover:rounded-md'>
                      <div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex justify-end'>
                        {isGSTEditing ? (
                          <input
                            type="text"
                            value={GSTValue}
                            onChange={(e) => {setGSTValue(e.target.value); selectedHub.gst = e.target.value}}
                            className="border border-gray-300 w-24 rounded px-2 py-1"
                          />
                        ) : (
                          <p>{selectedHub.gst}</p>
                        )}
                      </div>

                    </div>
                  </div>
                  <div className='flex flex-row pb-2'>
                    <div className='text-[#212529] text-xs pt-2 pl-2 pr-2 w-32'>
                      <h1>PAN</h1>
                    </div>
                    <div className='flex flex-row hover:bg-[#d7d7ec] hover:rounded-md'>
                      <div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex justify-end'>
                        {isPanEditing ? (
                          <input
                            type="text"
                            value={panValue}
                            onChange={(e) => {setPanValue(e.target.value); selectedHub.pan = e.target.value}}
                            className="border border-gray-300 w-24 rounded px-2 py-1"
                          />
                        ) : (
                          <p>{selectedHub.pan}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div onClick={handleToggleLocation}  className='pt-4 pl-4 pr-4 border-b flex flex-row justify-between items-center'>
                <span className='text-sm cursor-pointer' onClick={handleToggleLocation}>LOCATION</span>
                <button className='ml-2 text-gray-500 hover:text-gray-800 transition duration-300 ease-in-out' onClick={handleToggleLocation}>
                  {showLocation? <FontAwesomeIcon icon={faChevronUp} className='text-xs'/> : <FontAwesomeIcon icon={faChevronDown} className='text-xs'/>}
                </button>
              </div>
              <div className={`${showLocation ? '' : 'hidden'} mt-2 mb-2 flex flex-col`}>
                <div className='flex flex-row  hover:rounded-md'>
                  <div className='flex-1 text-xs pt-2 pb-2 pl-1 pr-1 flex'>
                    <div className='flex flex-col pb-2 space-y-2'>
                      <div className='flex flex-col space-y-1 ml-3'>
                        <label className='font-semibold mb-0.5'>Latitude</label>
                        <input className='border border-gray-300 p-1 rounded' type='text' value={selectedHub?.latitude||selectedHub?.latitude} readOnly />
                      </div>
                     
                      <div className='flex flex-col space-y-1 ml-3'>
                        <label className='font-semibold mb-0.5'>Longitude</label>
                        <input className='border border-gray-300 p-1 rounded' type='text' value={selectedHub?.longitude||selectedHub?.longitude} readOnly />
                      </div>
                     
                    </div>
                    <div className='flex flex-col w-full justify-center items-center'>
                     <FontAwesomeIcon
                          icon={faMapMarkerAlt}
                          className="text-blue-500 border border-black p-1 w-8 h-8 cursor-pointer" // Increased size with w-8 and h-8
                          onClick={openGoogleMaps} />
                       </div>
                  </div>
                </div>
              </div>
              </div>
  
              <div className="w-[68%] pl-2">
                <div className="w-full">
                  <div className="flex flex-col justify-center items-center">
                    <div className="flex flex-col justify-center items-center">
                      <div className="overflow-x-auto w-full container mx-auto px-4">
                        {selectedHub.name} 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex justify-center items-center h-full">
            <p className="text-gray-500">Select a hub to view details</p>
          </div>
        )}
      </div>
    </div>
  );
}
  
export default HubDetails;